import { Link } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../utils/formatPrice";
import { mediaUrl } from "../services/api";
import CouponInput from "../components/checkout/CouponInput";

export default function Cart() {
  const { items, updateQuantity, removeFromCart, subtotal, deliveryFee, discount, total, coupon } = useCart();

  if (items.length === 0) {
    return (
      <div className="container-queen pt-36 pb-24 text-center" id="main">
        <div className="w-20 h-20 rounded-full bg-[#F8F8F6] border border-[#EAE8E4] grid place-items-center mx-auto text-[#111111]">
          <ShoppingBag size={32} />
        </div>
        <h1 className="font-display text-[#111111] mt-8 text-4xl">Votre panier est vide</h1>
        <p className="text-[#666666] text-sm mt-2 max-w-sm mx-auto">
          Découvrez nos sérums dermatologiques de pointe pour composer votre rituel The Queen.
        </p>
        <Link to="/shop" className="btn-queen-primary mt-8">Découvrir les Sérums</Link>
      </div>
    );
  }

  return (
    <div className="container-queen pt-32 pb-24" id="main">
      <h1 className="font-display text-[#111111] mb-10 text-4xl sm:text-5xl">Mon Rituel de Soin</h1>
      <div className="grid lg:grid-cols-[1fr_400px] gap-12">
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.key} className="flex gap-5 bg-white rounded-2xl p-5 border border-[#EAE8E4]" data-testid={`cart-page-item-${item.slug}`}>
              <Link to={`/product/${item.slug}`} className="shrink-0 rounded-xl overflow-hidden bg-[#F8F8F6] w-24 h-28 p-1.5 flex items-center justify-center">
                <img src={mediaUrl(item.image)} alt={item.name} className="w-full h-full object-contain mix-blend-multiply" />
              </Link>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <Link to={`/product/${item.slug}`}>
                    <h3 className="font-display text-xl text-[#111111] hover:text-[#555555] transition-colors leading-tight">{item.name}</h3>
                  </Link>
                  <p className="text-[#111111] font-semibold mt-1.5 text-base">{formatPrice(item.price)}</p>
                </div>
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center border border-[#EAE8E4] rounded-full bg-white">
                    <button onClick={() => updateQuantity(item.key, item.quantity - 1)} className="w-8 h-8 grid place-items-center text-[#666666] hover:text-[#111111]" aria-label="Diminuer">
                      <Minus size={14} />
                    </button>
                    <span className="w-8 text-center text-xs font-semibold">{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.key, item.quantity + 1)} className="w-8 h-8 grid place-items-center text-[#666666] hover:text-[#111111]" aria-label="Augmenter">
                      <Plus size={14} />
                    </button>
                  </div>
                  <button onClick={() => removeFromCart(item.key)} className="text-[#888888] hover:text-red-600 transition-colors flex items-center gap-1.5 text-xs font-medium" aria-label="Supprimer">
                    <Trash2 size={15} /> Retirer
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:sticky lg:top-28 h-fit bg-white rounded-3xl border border-[#EAE8E4] p-7 space-y-6">
          <h2 className="font-display text-2xl text-[#111111]">Récapitulatif</h2>
          <CouponInput subtotal={subtotal} />
          <div className="space-y-3 pt-3 text-xs font-body">
            <div className="flex justify-between text-[#666666]"><span>Sous-total</span><span className="text-[#111111] font-medium">{formatPrice(subtotal)}</span></div>
            {discount > 0 && <div className="flex justify-between text-emerald-700"><span>Privilège {coupon?.code ? `(${coupon.code})` : ""}</span><span>-{formatPrice(discount)}</span></div>}
            <div className="flex justify-between text-[#666666]">
              <span>Livraison</span>
              <span className="text-[#111111]">
                {deliveryFee === 0 ? "Offerte" : deliveryFee === null ? "Calculée à l'étape suivante" : formatPrice(deliveryFee)}
              </span>
            </div>
            <div className="flex justify-between items-baseline pt-4 border-t border-[#EAE8E4]">
              <span className="font-display text-lg text-[#111111]">Total net</span>
              <span className="font-body text-2xl font-bold text-[#111111]">
                {total === null ? `${formatPrice(subtotal - discount)}` : formatPrice(total)}
              </span>
            </div>
          </div>
          <Link to="/checkout" className="btn-queen-primary w-full h-12 uppercase tracking-wider text-xs" data-testid="cart-page-checkout">
            Passer la commande <ArrowRight size={15} />
          </Link>
          <Link to="/shop" className="btn-queen-ghost w-full justify-center text-xs">Continuer mes découvertes</Link>
        </div>
      </div>
    </div>
  );
}
